export default "__VITE_ASSET__a38d2f2b__"